import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeagueSeasonGameCreateEditForm from './Components/LeagueSeasonGameCreateEditForm';
import LeagueSeasonGameApi from './LeagueSeasonGameApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeagueSeasonGameCreateEditForm,
                getCreate: LeagueSeasonGameApi.create,
                getClone: LeagueSeasonGameApi.getOne,
                defaults: { teamIds: [], status: "scheduled" },
                successMessage: "LeagueSeasonGame Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}